import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Approuter from "./routes/router";

function App() {
  return (
    <BrowserRouter>
      <video
        className="app-video-bg"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src="/assets/common/main-bg.mp4" type="video/mp4" />
      </video>
      <Approuter />
    </BrowserRouter>
  );
}

export default App;
